/**
 * Bottom tabs stay in one order for each role. Agent and homeowner
 * orders are different on purpose; a screen must not invent a third.
 * Homeowner words come from homeownerNav so the phone and desktop match.
 */

const { homeownerTabs } = require('./homeownerNav');

const AGENT_MOBILE_TABS = [
  { id: 'dashboard', label: 'Home' },
  { id: 'assistant', label: 'AI' },
  { id: 'projects', label: 'Projects' },
  { id: 'tasks', label: 'Tasks' },
  { id: 'settings', label: 'More' },
];

const HOMEOWNER_MOBILE_TABS = homeownerTabs([
  'overview',
  'tasks',
  'assistant',
  'projects',
  'settings',
]);

function incompleteProjectTaskCount(projects) {
  return (projects || []).reduce((sum, project) => {
    const tasks = project && Array.isArray(project.tasks) ? project.tasks : [];
    return sum + tasks.filter((task) => task && typeof task === 'object' && task.completed !== true).length;
  }, 0);
}

/**
 * The Projects badge is the incomplete checklist count until the homeowner
 * opens Projects. Opening that tab clears it. A higher count (new work)
 * shows again. A zero count stays cleared.
 */
function projectTabBadgeCount(incompleteCount, seenCount, onProjectsTab) {
  const count = Math.max(0, Number(incompleteCount) || 0);
  if (count === 0) return 0;
  if (onProjectsTab) return 0;
  const seen = Math.max(0, Number(seenCount) || 0);
  return count > seen ? count : 0;
}

/**
 * Opening Projects marks the current count as seen. While the homeowner is
 * elsewhere, a drop in the count lowers that mark so a later increase
 * (even to a smaller number than before) shows again.
 */
function nextSeenProjectCount(seenCount, incompleteCount, onProjectsTab) {
  const count = Math.max(0, Number(incompleteCount) || 0);
  const seen = Math.max(0, Number(seenCount) || 0);
  if (onProjectsTab) return count;
  return Math.min(seen, count);
}

module.exports = {
  AGENT_MOBILE_TABS,
  HOMEOWNER_MOBILE_TABS,
  incompleteProjectTaskCount,
  projectTabBadgeCount,
  nextSeenProjectCount,
};
